export function isTrapId(id: number): boolean {
  return (id >= 60_000 && id < 70_000) || id == 1_000_002 || id == 1_000_402;
}

export function parseDeviceIdsSearchValue(value: string, maxRangeCount = 5000): number[] {
  const ids: number[] = [];
  const matches = value.matchAll(/(?<!\d)(\d+)\s*-\s*(\d+)|\d+/g);

  for (const match of matches) {
    if (match[1] && match[2]) {
      const from = Number(match[1]);
      const to = Number(match[2]);
      const start = Math.min(from, to);
      const end = Math.max(from, to);
      const count = end - start + 1;

      if (!Number.isFinite(count) || count > maxRangeCount) continue;
      ids.push(...Array.from({ length: count }, (_, index) => start + index));
      continue;
    }

    const id = Number(match[0]);
    if (Number.isFinite(id)) ids.push(id);
  }

  return ids;
}
